import api from './api';
import apiRunnerSplitPane from './apiRunnerSplitPane';
import apiTest from './apiTest';
import app from './app';
import common from './common';
import commonParameter from './commonParameter';
import component from './component';
import environment from './environment';
import http from './http';
import project from './project';
import response from './response';
import search from './search';
import settings from './settings';
import user from './user';

export default {
  ...common,
  ...settings,
  ...project,
  ...http,
  ...environment,
  ...apiTest,
  ...api,
  ...user,
  ...response,
  ...search,
  ...commonParameter,
  ...apiRunnerSplitPane,
  ...app,
  ...component,
};
